// Phase 0b: Convert-to-Pre-Award confirmation dialog. Sibling of
// ConvertToContractDialog but materially simpler — promotion is a one-shot,
// no form fields to collect. The backend freezes the bid baseline, spawns a
// new pre-award workspace, and returns its id; we route the user there on
// success.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useConvertToPreAward } from '../../hooks/useProjects';
export function ConvertToPreAwardDialog({ open, onOpenChange, project }) {
    const navigate = useNavigate();
    const convert = useConvertToPreAward();
    const handleConfirm = async ()=>{
        try {
            const summary = await convert.mutateAsync({
                proposalProjectId: project.projectId
            });
            toast.success('Pre-award workspace created.');
            onOpenChange(false);
            navigate(`/delivery/pre-award/${summary.preAwardProjectId}/v2`);
        } catch (err) {
            toast.error(err instanceof Error ? err.message : 'Failed to convert proposal to pre-award');
        }
    };
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(DialogContent, {
            className: "sm:max-w-[500px]",
            "data-testid": Testids.preAward.convertDialog,
            children: [
                /*#__PURE__*/ _jsxs(DialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsx(DialogTitle, {
                            children: "Promote to Pre-Award"
                        }),
                        /*#__PURE__*/ _jsxs(DialogDescription, {
                            children: [
                                "Freeze the submitted bid baseline and spawn a Pre-Award workspace. The eight SDS readiness areas (Staffing, Financial, Subcontractor, Schedule, Governance, Customer, Artifacts, Risk) are seeded in ",
                                /*#__PURE__*/ _jsx("strong", {
                                    children: "Not Started"
                                }),
                                ". The original proposal is untouched."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(DialogFooter, {
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "outline",
                            onClick: ()=>onOpenChange(false),
                            disabled: convert.isPending,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            onClick: handleConfirm,
                            disabled: convert.isPending,
                            "data-testid": Testids.preAward.convertConfirm,
                            children: convert.isPending ? 'Promoting…' : 'Promote to Pre-Award'
                        })
                    ]
                })
            ]
        })
    });
}
